import BaseService from "src/packages/BaseService";

export default class UserLessonService extends BaseService {
	static get className () {
		return "user";
	}

  	static changePassword(passwords){
		return BaseService.getService().post("user/change",  passwords ).then(
			response => {
				return response.data;
			},
		);
	}
  static selectMosad(mosad){
    return BaseService.getService().post("user/select_mosad",  mosad ).then(
      response => {
        return response.data;
      },
    );
  }
};
